import { Link } from "react-router-dom";
import { listOffers } from "@/config/offers";

interface OfferPickerScreenProps {
  /** When true, selecting an offer invokes callback instead of routing to /:offerId/start. */
  embedded?: boolean;
  onSelectOffer?: (offerId: string) => void;
}

/** Home / hub — pick obligations export vs SOP coverage. */
export function OfferPickerScreen({ embedded = false, onSelectOffer }: OfferPickerScreenProps) {
  const offers = listOffers();

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-1 flex-col justify-center px-5 py-16">
      <h1 className="text-3xl font-extrabold leading-tight text-ink sm:text-4xl">
        Get started
      </h1>
      <p className="mt-3 text-lg text-ink-soft">Choose your workflow.</p>

      <ul className="mt-10 flex flex-col gap-4">
        {offers.map((offer) => (
          <li key={offer.offerId}>
            {embedded && onSelectOffer ? (
              <button
                type="button"
                onClick={() => onSelectOffer(offer.offerId)}
                className="block w-full rounded-2xl border border-slate-200 bg-white p-6 text-left shadow-sm transition hover:border-brand-400 hover:shadow-md"
              >
                <OfferCardContent offer={offer} />
              </button>
            ) : (
              <Link
                to={{ pathname: `/${offer.offerId}/start`, search: window.location.search }}
                className="block rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-brand-400 hover:shadow-md"
              >
                <OfferCardContent offer={offer} />
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

function OfferCardContent({
  offer,
}: {
  offer: { title: string; subtitle?: string; pricing?: { fromPriceLabel?: string; priceRangeLabel?: string } };
}) {
  return (
    <>
      <h2 className="text-xl font-bold text-ink">{offer.title}</h2>
      {offer.subtitle ? <p className="mt-2 text-ink-soft">{offer.subtitle}</p> : null}
      {offer.pricing?.fromPriceLabel ? (
        <p className="mt-3 text-sm font-medium text-brand-700">{offer.pricing.fromPriceLabel}</p>
      ) : null}
      {offer.pricing?.priceRangeLabel ? (
        <p className="mt-1 text-xs text-ink-muted">{offer.pricing.priceRangeLabel}</p>
      ) : null}
    </>
  );
}
